import L from 'leaflet';

const createIotDeviceIcon = () => {
  const pinColor = '#0d3825';
  const ringColor = 'white';
  const iconColor = '#0d3825';

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${pinColor}"/>

      <!-- State ring -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${ringColor}" stroke="${ringColor}" stroke-width="12.6"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- IoT device icon (person) -->
      <g transform="translate(123.75, 123.75) scale(2.2) translate(-30, -30)">
        <g transform="translate(30, 30) scale(0.6) translate(-32, -30.5)">
          <circle cx="32" cy="12" r="8" fill="${iconColor}"/>
          <path d="M25 23 C23 23 21 25 21 27.5 L21 38 C21 39.7 22.3 41 24 41 L27 41 L27 53 C27 55.2 28.8 57 31 57 L33 57 C35.2 57 37 55.2 37 53 L37 41 L40 41 C41.7 41 43 39.7 43 38 L43 27.5 C43 25 41 23 39 23 Z" fill="${iconColor}"/>
        </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const IotDeviceIcon = () => {
  var icon = new L.Icon({
    iconUrl: createIotDeviceIcon(),
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [94, 104],
    iconAnchor: [34, 75],
    className: 'custom-icon-marker iot-device-marker'
  });

  return icon;
};
